/*eslint-disable*/
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../bmr/components/common/FormikControl";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  addInBoundForm,
  updateInBoundForm,
  fetchDetailsInBound,
  selectbmrInBoundLoading,
  uploadFiles,
  deleteFile,
  submitInBoundForm,
  approveInBoundForm,
  receivedInBoundForm,
} from "../../bmr/slices/inbound";
import {
  fetchQueryList
} from "../../bmr/slices/queryInBound";
import {
  getNestedValue,
  MAX_FILE_SIZE,
  SUPPORTED_FORMATS,
  transformDataWithFiles,
  InboundFormPartASchema,
  InboundFormPartDSchema,
  InboundFormPartBSchema,
  SampleTypes,
  ALCDelcarationOption,
  DispatchModes,
  confirmationOptions,
  InboundFormPartCSchema,
  confirmationOptions1,
  BloodNotUsed
} from "./common-in-bound/common";
import FormikArrayInBound from "./common-in-bound/FormikArrayInBound";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import InBoundComment from "./common-in-bound/InBoundComment";
import InBoundQueryHistory from "./common-in-bound/InboundQueryHistory";
import {
  CheckGreen,
  DownIcon,
  InfoIcon,
} from "../../assets/common-svg/CommonSvg";
import DownloadImageApi from "../../services/downloadImageService";
import DeleteModal from "../../bmr/components/common/BaseModal/DeleteModal";
import { useSearchParams } from "react-router-dom";
import { hasAuthority, role } from "../../utils/authorities";
import RejectLSM from "../../bmr/components/features/RejectLSM";
import { filteredFormValues } from "../../utils/utils"
import LSMApprovalDetails from "./common-in-bound/lsmApprovalDetails";
import { selectCurrentCycle } from "../../bmr/slices/common";
import { notify } from "../../bmr/utils/methods/notification";
import BsModal from "../../bmr/components/common/BaseModal";
import ALCDelaration  from './common-pre-screen/ALCDelaration'
import { useReactToPrint } from 'react-to-print';
import QrAllPrintContent from "../../bmr/pages/LogisticsManagement/InBound/QrAllPrintContent"
import { selectDropDownDataMaster, fetchManufecturingButtonDropDown } from "../../bmr/slices/customMaster"

const InBoundForm = ({
  patientData,
  disabledAllFields = false,
  initialSteps=[],
  noQuery = false,
  printPatientInfo,
  updateTimeLine = () => { },
}) => {
  const printContentAllRef = useRef(null)
  const printTimeoutAllRef = useRef(null);
  const currentCycle = useSelector(selectCurrentCycle)
  const dispatch = useDispatch();
  const isLoading = useSelector(selectbmrInBoundLoading);
  const LoginData = useSelector((state) => state.loginData);
  const isInBoundPrint =['logistics-management','superadmin','editor','warehouse','quality-check','project-manager']?.includes(LoginData?.role_slug)
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const {role_id, role_slug} = LoginData;
  const resolveQueryUser = ['editor','project-manager']
  const isEditor = Boolean(resolveQueryUser?.includes(role_slug));
  const isLogistic = Boolean(['logistics-management']?.includes(LoginData?.role_slug));
  const [isDraft, setIsDraft] = useState(false);
  const [showALCModal, setShowALCModal] = useState(false)
  const [allPrintData, setAllPrintData] = useState({})
const LogisticsPartners = useSelector(
  selectDropDownDataMaster('logistics-partners')
);

const equipmentOptions = useSelector(
  selectDropDownDataMaster('equipment')
);
    const reactToPrintFnAll = useReactToPrint({
    content: () => printContentAllRef.current,
  }); 
  const canRaiseQueryOnFirstForm = hasAuthority(
    ["in-bound-view-details"],
    bmr_permissions
  );
  const canViewLSMKit = hasAuthority(["view-lsm-form"], bmr_permissions);

  const lsmKitRejected = useMemo(() => {
    return (
      initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 3
    );
  }, [initialSteps]);

  const lsmKitCompleted = useMemo(() => {
    return (
      initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 2
    );
  }, [initialSteps]);

  const canPartiallyApproveLSMKit = useMemo(() => {
    return (
      hasAuthority(["quality-check-approve"], bmr_permissions) && initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 4
    );
  }, [initialSteps, bmr_permissions]);

  const showALCKit = useMemo(() => {
    return (
      hasAuthority(["quality-check-approve"], bmr_permissions) || hasAuthority(["quality-check-reject"], bmr_permissions)
    );
  }, [initialSteps, bmr_permissions]);

  const canFinalApproveLSMKit = useMemo(() => {
    return (
      hasAuthority(["quality-analyst-approve"], bmr_permissions) && initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 5
    );
  }, [initialSteps, bmr_permissions]);

  const canSubmitedRejectLSMKit = useMemo(() => {
    return (
      hasAuthority(["warehouse-reject"], bmr_permissions) && initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 0 && initialSteps?.find((op) => op.slug === "lsm-received-bmr")?.status == 2
    );
  }, [initialSteps, bmr_permissions]);

  const canPartiallyRejectLSMKit = useMemo(() => {
    return (
      hasAuthority(["quality-check-reject"], bmr_permissions) && hasAuthority(["quality-check-approve"], bmr_permissions) && initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 4
    );
  }, [initialSteps, bmr_permissions]);

  const canFinalRejectLSMKit = useMemo(() => {
    return (
      hasAuthority(["quality-check-reject"], bmr_permissions) && hasAuthority(["quality-analyst-approve"], bmr_permissions) && initialSteps?.find((op) => op.slug === "lsm-qualified")?.status == 5
    );
  }, [initialSteps, bmr_permissions]);

  const LSMApprovalDetails = useMemo(() => {
    const status = initialSteps?.find((op) => op.slug === "accept-manufacturing")?.status
    return (
      hasAuthority(["accept-manufacturing"], bmr_permissions) && status != 0 && status != 6
    );
  }, [initialSteps, bmr_permissions]);


  const canViewLSMReceiptForm = hasAuthority(
    ["in-bound-marked-received"],
    bmr_permissions
  );
  const hasModulePermission = canViewLSMKit || canRaiseQueryOnFirstForm;
  const [searchParams] = useSearchParams();
  const [disabledAll, setDisabledAll] = useState(disabledAllFields);
  const [showRejectLSM, setShowRejectLSM] = useState(false);
  const [inBoundForm, setInBoundForm] = useState({});
  const [checkInBoundForm, setCheckInBoundForm] = useState({});
  const [queriesFields, setQueryFields] = useState([]);
  const [queriesNotResolved, setQueriesNotResolved] = useState([]);
  const [queryData, setQueryData] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);
  const disableDraftFields = useMemo(() => {
    return (
      initialSteps?.find((op) => op.slug === "lsm-received-bmr")?.status == 2 &&
      inBoundForm?.status == 1
    );
  }, [inBoundForm?.status, initialSteps]);
  const [enableForm1, setEnableForm1] = useState(false);
  const [enableForm2, setEnableForm2] = useState(false);
  const [enableForm3, setEnableForm3] = useState(false);
  const [enableForm4, setEnableForm4] = useState(false);

  const [enableSubmitButton, setEnableSubmitButton] = useState(false);
  const [lsmQuery, setLsmQuery] = useState(noQuery);
  const [InBoundFormExpanded, setInBoundFormExpanded] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl) || false;


  useEffect(() => {
  const fetchAll = async () => {
    const list = ['logistics-partners', 'equipment'];
    await Promise.all(
      list.map((it) =>
        dispatch(fetchManufecturingButtonDropDown(it))
      )
    );
  };
  fetchAll();
}, [dispatch]);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const now = new Date();
  const timeString = now.toTimeString().slice(0, 5); // "HH:MM"
  if (!isEditor && !hasModulePermission) return;

  const handleDeclarationModal = (event) => {
    const declaration = event?.target?.checked
    if(declaration){
      setShowALCModal(true);
    }else{
      setShowALCModal(false);
    }
  }
  // Initial Values for Inbound Form Part A
  const partDInitialValues = useMemo(
    () => ({
       media_id:inBoundForm?.logger_media
      ? inBoundForm?.logger_media
      : null
    }),
    [inBoundForm, patientData]
  );
  // Initial Values for Inbound Form Part A
  const partAInitialValues = useMemo(
    () => ({
      // SECTION A - Patient Demographics
      hospital_name:
        patientData?.hospital_details?.name ||
        inBoundForm?.hospital?.name ||  patientData?.patient_information?.hospital || 
        "",
      hospital_patient_id:
       patientData?.hospital_patient_id || "",
      immunoact_patient_id:
        patientData?.subject_code || inBoundForm?.patient?.subject_code || patientData?.patient_information?.immunoact_patient_id || "",
      full_name: patientData?.first_name
        ? `${patientData?.first_name} ${patientData?.last_name}`
        : (inBoundForm?.patient?.first_name || inBoundForm?.patient?.last_name) ? `${inBoundForm?.patient?.first_name ?? ""} ${inBoundForm?.patient?.last_name ?? ""
        }`:patientData?.patient_information?.name || '',
      initials:
        patientData?.sub_initials || inBoundForm?.patient?.sub_initials || patientData?.patient_information?.patient_initials || "",
      dob: patientData?.dob
        ? new Date(patientData?.dob)
        : inBoundForm?.patient?.dob
          ? new Date(inBoundForm?.patient?.dob)
          : patientData?.patient_information?.dob ? new Date(patientData?.patient_information?.dob) : "",
      disease_indication:
        patientData?.disease?.name || inBoundForm?.patient?.disease?.name || patientData?.patient_information?.disease || "",
      patient_weight: Object.keys(inBoundForm).length > 0 ? inBoundForm?.patient_weight : patientData?.patient_information?.body_weight ? patientData?.patient_information?.body_weight : "",

      // SECTION B - Sample Information
      sample_types: inBoundForm?.sample_types
        ? Array.isArray(inBoundForm?.sample_types)
          ? inBoundForm.sample_types
          : JSON.parse(inBoundForm?.sample_types)
        : [],
      lsm_bag_quantity:
        inBoundForm?.lsm_bag_quantity || patientData?.number_of_bags || "",
      blood_tube_quantity: inBoundForm?.blood_tube_quantity ?? null,
      lsm_volumes: inBoundForm?.lsm_volumes
        ? inBoundForm?.lsm_volumes
        : Array.from(
          { length: patientData?.number_of_bags || 1 },
          (_, index) => ({
            bag_no: (index + 1).toString(), // Convert to string as per your requirement
            volume: "", // Empty string as per your requirement
            blood_not_used: [],
          })
        ),

      sample_photo: inBoundForm?.samplePhoto
        ? [inBoundForm?.samplePhoto]
        : null,

      // SECTION C - Collection Timeline
      collection_date: inBoundForm?.collection_date
        ? new Date(inBoundForm?.collection_date)
        : new Date(),
      start_time: inBoundForm?.start_time ? inBoundForm?.start_time?.split(":").slice(0, 2).join(":"):'',
      stop_time: inBoundForm?.stop_time ? inBoundForm?.stop_time?.split(":").slice(0, 2).join(":"):'',
      // SECTION D - Dispatch Information
      mode_of_dispatch: inBoundForm?.mode_of_dispatch ?? "",
      logistics_partner: inBoundForm?.logistics_partner ?? "",
      data_logger_used: inBoundForm?.data_logger_used ?? "",
      data_logger_serial_no: inBoundForm?.data_logger_serial_no ?? "",
      equipment_id: inBoundForm?.equipment_id ?? "",
      date_of_dispatch: inBoundForm?.date_of_dispatch
        ? new Date(inBoundForm?.date_of_dispatch)
        : "",
      temperature_at_dispatch: inBoundForm?.temperature_at_dispatch ?? "",
      time_of_dispatch: Object.keys(inBoundForm)?.length > 0 ? inBoundForm?.time_of_dispatch?.split(":").slice(0, 2).join(":") : timeString,
      upload_report_log_file: inBoundForm?.reportLogFile
        ? [inBoundForm?.reportLogFile]
        : null,
      editor_name: inBoundForm?.submitted_by || patientData?.editor?.name || inBoundForm?.editor_name || (role_slug == 'project-manager' ? LoginData?.name:"") ,
      alc: inBoundForm?.alc ?? "",
      showAlcDeclaration: [inBoundForm?.alc_declaration] ?? [],
      alc_declaration: inBoundForm?.alc_declaration ? [inBoundForm?.alc_declaration] : [],
    }),
    [inBoundForm, patientData]
  );
  // Initial Values for Inbound Form Part B
  const partBInitialValues = {
    // SECTION E - Receipt Information
    date_of_receipt: !isNaN(Date.parse(inBoundForm?.date_of_receipt))
      ? new Date(inBoundForm?.date_of_receipt)
      : "",
    temperature_at_receipt: inBoundForm?.temperature_at_receipt ?? "",
    time_of_receipt: inBoundForm?.time_of_receipt ?? "",
    quantity_received: inBoundForm?.quantity_received ?? "",
    leakage: inBoundForm?.leakage ?? false,
    seal_broken: inBoundForm?.seal_broken ?? false,
    transport_box_damaged: inBoundForm?.transport_box_damaged ?? false,
    leakage_comment: inBoundForm?.leakage_comment ?? "",
    seal_broken_comment: inBoundForm?.seal_broken_comment ?? "",
    transport_box_damaged_comment: inBoundForm?.transport_box_damaged_comment ?? "",
    receipt_photo: inBoundForm?.receiptPhoto
      ? [inBoundForm?.receiptPhoto]
      : null,
    remarks: inBoundForm?.remarks ?? "",
  };
  // Initial Values for Inbound Form Part C
  const partCInitialValues = {
    // SECTION F - ALC Information & Declaration
    cd3_count: inBoundForm?.cd3_count ?? null,
    comment: inBoundForm?.comment ?? "",
    reason_id: inBoundForm?.reason ?? null,
    criteria_met: (inBoundForm?.criteria_met == null || inBoundForm?.criteria_met) ? 1 : 0,
    temperature_excursion_comment: inBoundForm?.temperature_excursion_comment ?? "",
    excursion_time: inBoundForm?.excursion_time ?? "",
    excursion_temp: inBoundForm?.excursion_temp ?? null,
    excursion_duration: inBoundForm?.excursion_duration ?? "",
    temperature_excursion: inBoundForm?.temperature_excursion ?? false,
    declaration_to_proceed: inBoundForm?.declaration_to_proceed ?? "",
  };
  const fetchInboundDetails = useCallback(
    async (id) => {
      const inBoundId = id || currentCycle?.inbond_patients_id
      const res = await dispatch(fetchDetailsInBound({ inBoundId, feasibility_assessments: currentCycle?.feasibility_assessments_id }));

      if (res?.payload?.status == 200) {
        const { lsm_volumes, sample_types } = res.payload.data;
        const transformedData = {
          ...res.payload.data,
          lsm_volumes: lsm_volumes ? JSON.parse(lsm_volumes) : [],
          sample_types: sample_types ? JSON.parse(sample_types) : [],
        };

        let data = transformDataWithFiles(transformedData);
        setInBoundForm(data);
        setCheckInBoundForm(data);       
        setQueryFields(data?.queries);
        setQueriesNotResolved(data?.queries?.filter((it)=>it?.resolve != 1))
      }
    },
    [patientData, currentCycle?.inbond_patients_id, dispatch]
  );

  useEffect(() => {
    // Disable the form when on the basis of status
    if (lsmKitRejected) {
      setDisabledAll(true);
    }
    if ((inBoundForm?.status && inBoundForm?.status > 1) || canViewLSMKit) {
      setDisabledAll(true);
    }
    if (inBoundForm?.status >= 1 || canViewLSMKit) {
      const shouldDisable = isEditor || inBoundForm?.status >= 2;
      if (shouldDisable) {
        setDisabledAll(true);
      }
    }
  }, [inBoundForm?.status, canViewLSMKit, isEditor]);
  useEffect(() => {
    if (currentCycle?.inbond_patients_id) {
      fetchInboundDetails();
    }else{
      setInBoundForm({})
      setDisabledAll(false);
    }
  }, [patientData, currentCycle?.inbond_patients_id, fetchInboundDetails]);

  useEffect(() => {
    if (initialSteps?.length > 0) {
      const apheresisStatus = initialSteps.find(
        (op) => op.slug === "apheresis"
      )?.status;
      const lsmStatus = initialSteps.find(
        (op) => op.slug === "lsm-received-bmr"
      )?.status;
      setLsmQuery(!(apheresisStatus !== 0 && apheresisStatus !== 1))
      const verifyLSM = initialSteps.find(
        (op) => op.slug === "lsm-qualified"
      )?.status;
      setEnableForm1(apheresisStatus >= 1);
      setEnableForm4(lsmStatus === 2)
      setEnableForm2(lsmStatus === 2 && !isLogistic);
      const checkEnableForm = verifyLSM == 4 || verifyLSM == 5 || verifyLSM == 2
      if (showALCKit || (verifyLSM == 2 && role_slug == 'manufacture'))
        setEnableForm3(checkEnableForm)
       if(!showALCKit || !checkEnableForm){
        const queryData = queriesFields?.filter((it) => it?.fields?.field_name !== 'alc' && it?.fields?.field_name !== 'criteria_met')
        setQueryFields(queryData)
      }
      setEnableSubmitButton(
        (apheresisStatus === 1 && lsmStatus !== 2) ||
        (apheresisStatus === 2 && lsmStatus === 2 && inBoundForm?.status != 2)
      );
    }
  }, [initialSteps, inBoundForm?.status, showALCKit, isLogistic, role_slug ]);
  const handleDownload = async (id) => {
    try {
      const imgRes = await DownloadImageApi.getDownloadedImageul(id);
      const response = await fetch(imgRes?.data || "");

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      return response?.url;
    } catch (error) {
      notify.error("Download failed. Please try again later.");
    }
  };

  const keysToRemove = [
    "hospital_name",
    "hospital_patient_id",
    "immunoact_patient_id",
    "full_name",
    "initials",
    "dob",
    "disease_indication",
  ];


    const handleSaveLoggerData = async(values) => {
     try {
      const mediaIds = values?.media_id?.map(item => item?.id);
    const formData = new FormData();
    formData.append('media_id', JSON.stringify(mediaIds));
     const res = await dispatch(
          updateInBoundForm({ id: inBoundForm?.id, data:formData })
        );

      if (updateInBoundForm.fulfilled.match(res)) {
        updateTimeLine();
        fetchInboundDetails(); // refetch details to form behave acc. to updated details
        setInBoundFormExpanded(false);
      }
      } catch (err) {
         console.error(err);
        }
  }

  const handleSubmit = async (values) => {
    try {
      let deepCopiedValues = structuredClone(values);
      const formData = new FormData();
      keysToRemove.forEach((key) => delete deepCopiedValues[key]);
      // Transforming form values for submission
      if(!isDraft){
          const hasAtLeastOneVolume = Array.isArray(deepCopiedValues?.lsm_volumes) &&
            deepCopiedValues.lsm_volumes.some(item => item?.volume && item.volume !== "");
            if(!hasAtLeastOneVolume){
              notify.error('At least one LSM Volumn should be filled.')
               return false
            }
      }
      const transformedFormValues = {
        ...deepCopiedValues,
        patient_weight:deepCopiedValues?.patient_weight,
        is_draft : isDraft ? 1 : 0,
        sample_types: deepCopiedValues?.sample_types ? JSON.stringify(deepCopiedValues?.sample_types):'',
        lsm_volumes: deepCopiedValues?.lsm_volumes ? JSON.stringify(deepCopiedValues?.lsm_volumes):'',
        collection_date: deepCopiedValues.collection_date ? moment(
          deepCopiedValues.collection_date,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"):'',
        date_of_dispatch:   deepCopiedValues.date_of_dispatch ? moment(
          deepCopiedValues.date_of_dispatch,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"):'',
        sample_photo: deepCopiedValues?.sample_photo && deepCopiedValues?.sample_photo?.length > 0
          ? deepCopiedValues?.sample_photo?.map(op => op.id)
          : null,
        upload_report_log_file: deepCopiedValues?.upload_report_log_file?.length > 0
          ? deepCopiedValues?.upload_report_log_file?.map(op => op.id)
          : null,
          patient_weight: deepCopiedValues?.patient_weight || '',
          blood_tube_quantity: deepCopiedValues?.blood_tube_quantity || ''
      };

      if (Number(deepCopiedValues?.alc) >= 2 || !transformedFormValues.alc_declaration || transformedFormValues?.alc_declaration?.length < 1) {
        delete transformedFormValues.alc_declaration;
      }
      Object.entries(transformedFormValues).forEach(([key, value]) => {
         formData.append(key, value);
      });
      formData.append('feasibility_assessments_id', currentCycle?.feasibility_assessments_id);
      if(!deepCopiedValues?.editor && !patientData?.patient_information?.submitted_by)
      formData.append('project_manager', LoginData?.loginId);
      const res = await dispatch(
        addInBoundForm({
          data: formData,
          patient_id: patientData?.patient_id,
          hospital_id: patientData?.hospital_details?.id,
          id: inBoundForm?.id || ''
        })
      );
    
    if(addInBoundForm?.fulfilled?.match(res)){
       fetchInboundDetails(res?.payload?.data?.id);
    }
      if(!isDraft){
      setDisabledAll(true);
      setInBoundForm((prev) => ({ ...prev, status: 1 }));
      await updateTimeLine();
      }
      setInBoundFormExpanded(false);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSubmitRejectLSM = async () => {
    setShowRejectLSM(false)
    setInBoundForm((prev) => ({ ...prev, status: 1 }));
    await updateTimeLine();
  }
  const handleFinalApprove = async (values) => {
    try {

      if (!isDraft && (!inBoundForm?.logger_media || inBoundForm?.logger_media?.length === 0)) {
        notify.error('Since the Data Logger file has not been uploaded by the Logistics team, access to the submission is temporarily restricted.')
       return false
      }
      const receipt = moment(values?.time_of_receipt, "HH:mm:ss").format("HH:mm")
      const duration = values?.excursion_duration ? moment(values?.excursion_duration, "HH:mm:ss").format("HH:mm") : ''
      const time = values?.excursion_time ? moment(values?.excursion_time, "HH:mm:ss").format("HH:mm") : ''
      // Transform values and include additional patient data
      const transformedFormValues = {
        ...values,
        is_draft : isDraft ? 1 : 0,
        time_of_receipt: receipt,
        excursion_duration: duration,
        excursion_time: time,
        criteria_met: values?.criteria_met == 1 ? true : false,
        qrCode_id: patientData?.qrCode_id,
        patient_id: patientData?.patient_id
      };

  
      // First dispatch
      await dispatch(
        receivedInBoundForm({
          data: transformedFormValues,
          inboundId: currentCycle?.inbond_patients_id,
          feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
        })
      ).unwrap();

      if(!isDraft){
      // Second dispatch
      await dispatch(
        approveInBoundForm({
          logisticsOperationsId: currentCycle?.logistic_id,
          data: {feasibility_assessments_id:currentCycle?.feasibility_assessments_id},
        })
      ).unwrap();
  
      // Update UI and state
      await updateTimeLine();
    }
      setInBoundFormExpanded(false);
    } catch (err) {
      console.error(err);
    }
  };


  const handleCompleteFormSubmit = async (values) => {
    try {
      inboundFormPartAFieldsData.forEach(({ name }) => delete values[name]);
      // Transforming form values for submission
      const transformedFormValues = {
        ...values,
        qrCode_id: patientData?.qrCode_id,
        patient_id: patientData?.patient_id,
        date_of_receipt: values.date_of_receipt
          ? moment(values.date_of_receipt, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "",
        receipt_photo: values?.receipt_photo?.length > 0
          ? values?.receipt_photo?.map(op => op.id)
          : null,
          is_draft : isDraft ? 1 : 0
      };
      const res = await dispatch(
        submitInBoundForm({
          data: transformedFormValues,
          inboundId: currentCycle?.inbond_patients_id,
          feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
          id: inBoundForm?.id
        })
      );
      if (submitInBoundForm.fulfilled.match(res)) {
        updateTimeLine();
        fetchInboundDetails(); // refetch details to form behave acc. to updated details
        setInBoundFormExpanded(false);
      }
    } catch (err) {
      console.error(err);
    }
    // resetForm(); // Reset form after successful submission
  };

const filterQueryData = (listObj = []) => {
  const objKeys = listObj
    .map(it => it?.name)
    .filter(Boolean);

  const queryData = (queriesFields || []).filter(
    it => it?.fields?.field_name && !objKeys.includes(it.fields.field_name)
  );

  setQueryFields(queryData);
};
  
  const formik = useFormik({
    initialValues: useMemo(() => {
      if (enableForm1 && isEditor) return partAInitialValues;
      if (enableForm3) return { ...partAInitialValues,...partDInitialValues, ...partBInitialValues, ...partCInitialValues }
      if (enableForm2) return { ...partAInitialValues,...partDInitialValues, ...partBInitialValues };
      if (enableForm4) return { ...partAInitialValues, ...partDInitialValues };
      if (enableForm1) return partAInitialValues;
      return {};
    }, [
      enableForm1,
      enableForm2,
      enableForm4,
      isEditor,
      partAInitialValues,
      partBInitialValues,
      partCInitialValues,
      partDInitialValues,
      inBoundForm
    ]),
    validateOnBlur: false,
    validationSchema:
      enableForm1 && isEditor ? InboundFormPartASchema(isDraft) : enableForm3 && !isEditor ? InboundFormPartCSchema((!lsmKitRejected && canFinalApproveLSMKit) ? true : false, isDraft) :enableForm4 && isLogistic ? InboundFormPartDSchema() :  InboundFormPartBSchema(isDraft),
    enableReinitialize: true,
    onSubmit: isEditor ? handleSubmit  : canPartiallyApproveLSMKit ? handleFinalApprove : ['logistics-management']?.includes(LoginData?.role_slug) ? handleSaveLoggerData : handleCompleteFormSubmit,
  });

  const handleUploadFile = async (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (!file) return;
    const validFile =
      SUPPORTED_FORMATS.includes(file.type || file.file_type_) &&
      (file.size <= MAX_FILE_SIZE || file.file_size <= MAX_FILE_SIZE);

    if (!validFile) {
      formik.setFieldError(
        name,
        "Files must be of supported format and under 25MB"
      );
      return;
    }
    const formData = new FormData();
    formData.append(name, file);
    const res = await dispatch(
      uploadFiles({
        data: formData,
        id: patientData?.patient_id || inBoundForm?.patient_id,
      })
    );
    if (res?.payload?.data) {
      // Always set as array
      formik.setFieldValue(name, [res?.payload?.data?.[0]]);
    }
  };

  const hanldeRemoveFiles = async () => {
    const res = await dispatch(deleteFile(deleteModal?.id));
    if (res?.payload?.status === 200) {
      formik.setFieldValue(deleteModal?.name, null);
    }
    setDeleteModal(null);
  };
  // Menu handlers
  const handleQuestionClick = async (event, formProps) => {
    const { name, type, label, options, isResolve } = formProps;
    const query = queriesFields?.find((op) => op.fields?.field_name == name);
    const element = event.currentTarget;
    const res = await dispatch(fetchQueryList(query?.field_id));
    if (res?.payload?.status == 200) {
      setQueryData(res?.payload?.data);
    } else {
      setQueryData([]);
    }
  const currentVal = formik.values[name];
    const value =
      type == "select" || type == "radio"
        ? options?.find((op) => {
        const optionValue = String(op.value);
        const currentValue = String(currentVal);
        if (currentVal === "false" && op.value === false) return true;
        if (currentVal === "true" && op.value === true) return true;
        
        // Regular string comparison
        return optionValue === currentValue;
      })?.label
        : getNestedValue(formik.values, name);
    setSelectedField({
      ...query,
      is_file: type == "file" ? true : false,
      field_label: label,
      isResolve:isResolve,
      field_name: name,
      inbound_id: currentCycle?.inbond_patients_id,
      patient_id: inBoundForm?.patient_id || patientData?.patient_id,
      field_value: value,
    });
    setAnchorEl(element);
  };

  const handleManualFormikValidaction = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setErrors(errors);

      const touchedFields = Object.keys(errors).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {});
      formik.setTouched(touchedFields);
      const errorList = Object.keys(errors)
        .map((key, index) => `${index + 1}. ${key}`)
        .join("\n");
        notify.error(`Following mandatory field(s) required:\n${errorList}`)
      return 0;
    } else {
      return 1;
    }
  };
  const inboundFormPartAFieldsData = useMemo(
    () => [
      // SECTION A
      { section: "PATIENT & COLLECTION DETAILS" },
      {
        label: "Hospital Name",
        type: "text",
        name: "hospital_name",
        placeholder: "Enter Hospital Name",
        disabled: true,
        noQuery: true,
        col: 2,
        isFirstPartField: true,
      },
      {
        label: "Hospital Patient ID",
        type: "text",
        name: "hospital_patient_id",
        placeholder: "Enter Hospital Patient ID",
        required: true,
        disabled: true,
        noQuery: true,
        col: 4,
        isFirstPartField: true,
      },
      {
        label: "ImmunoACT Patient ID",
        type: "text",
        name: "immunoact_patient_id",
        placeholder: "Enter ImmunoACT Patient ID",
        disabled: true,
        noQuery: true,
        col: 4,
        isFirstPartField: true,
      },
      {
        label: "Patient Full Name",
        type: "text",
        name: "full_name",
        placeholder: "Enter Patient Full Name",
        disabled: true,
        noQuery: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: "Patient Initials",
        type: "text",
        name: "initials",
        placeholder: "Enter Patient Initials",
        noQuery: true,
        disabled: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: "Date of Birth",
        type: "date",
        name: "dob",
        placeholder: "Enter Date of Birth",
        disabled: true,
        noQuery: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: "Disease Indication",
        type: "text",
        name: "disease_indication",
        placeholder: "Enter Disease Indication",
        disabled: true,
        noQuery: true,
        col: 3,
        isFirstPartField: true,
      },
      {
        label: "Patient Weight at Leukapheresis (kg)",
        type: "number",
        name: "patient_weight",
        placeholder: "Enter Patient Weight at Leukapheresis (kg)",
        required: true,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        noQuery: noQuery,
        isResolve: resolveQueryUser,
        col: 3,
        isFirstPartField: true,
      },

      // SECTION B
      { section: "SAMPLE TYPE & QUANTITY" },
      {
        label: "Sample Types",
        type: "checkbox",
        name: "sample_types",
        placeholder: "Select Sample Types",
        multiple: true,
        required: true,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        options: SampleTypes,
        noQuery: noQuery,
        isResolve: resolveQueryUser,
        col: 2,
        isFirstPartField: true,
      },
      {
        label: "LSM Bag Quantity",
        type: "number",
        name: "lsm_bag_quantity",
        placeholder: "Enter LSM Bag Quantity",
        required: true,
        depend: "sample_types",
        dependValue: "fresh_lsm,cryo_lsm",
        disabled: true,
        max: 100,
        col: 2,
        noQuery: true,
        isFirstPartField: true,
      },
      {
        label: "Blood Tube Quantity",
        type: "number",
        name: "blood_tube_quantity",
        placeholder: "Enter Blood Tube Quantity",
        required: true,
        noQuery: noQuery,
        depend: "sample_types",
        dependValue: "blood_samples",
        disabled: disabledAll || !isEditor || lsmKitRejected,
        col: 2,
         isResolve: resolveQueryUser,
        isFirstPartField: true,
      },
      {
        label: "LSM Volumes per Bag",
        subLabel: "Enter LSM volumes for each bag",
        type: "textarea",
        name: "lsm_volumes",
        placeholder: "Enter LSM Volumes per Bag",
        disabled: false,
        manualValues: true,
        initialChildrenData: { bag_no: "", volume: "" },
        multipleField: true,
        hideDeleteIcon: true,
        noQuery: lsmQuery,
         isResolve: resolveQueryUser,
        hideAddIcon: true,
        col: 3,
        max: 100,
        isFirstPartField: true,
        children: (index) => {
          const bags = formik.values?.lsm_volumes?.[index]?.blood_not_used?.includes("blood_not_used") ?? false;
          return [
            {
              label: "  ",
              type: "checkbox",
              name: `lsm_volumes.${index}.blood_not_used`,
              multiple: false,
              required: false,
              noQuery: true,
              options: BloodNotUsed,
              col: 2,
              isFirstPartField: true,
               disabled: (() => {
                const currentVolume = formik.values?.lsm_volumes?.[index]?.volume;
                return !!currentVolume || disabledAll || !isEditor || lsmKitRejected; // Disable checkbox if volume filled
              })(),
            },
            {
              label: "Bag No",
              type: "number",
              name: `lsm_volumes.${index}.bag_no`,
              required: true,
              disabled: true,
              noQuery: true,
              placeholder: "Enter Bag No",
              manualError: true,
              isFirstPartField: true,
            },
            {
              label: "Volume (ml)",
              type: "number",
              name: `lsm_volumes.${index}.volume`,
              required: true,
              placeholder: "Enter Volume (ml)",
              disabled: formik.values?.lsm_volumes?.[index]?.blood_not_used?.includes("blood_not_used") || disabledAll || !isEditor || lsmKitRejected,
              manualError: true,
              noQuery: lsmQuery,
              isResolve: resolveQueryUser,
              isFirstPartField: true,
            },
          ].filter(Boolean);
        },
      },
      {
        label: "Upload CBC report / ALC count report",
        type: "file",
        name: "sample_photo",
        placeholder: "Upload CBC report / ALC count report",
        // acceptFormat: ["image/*"],
        noQuery: noQuery,
        acceptFormat: SUPPORTED_FORMATS, /// This should be only accept image format change it later.
        disabled: disabledAll || !isEditor || lsmKitRejected,
        removeButton: isEditor,
        onChange: handleUploadFile,
        removeFile: (name, id) => {
          setDeleteModal({ name: name, id: id });
        },
        downloadFile: handleDownload,
        col: 1,
         isResolve: resolveQueryUser,
        isFirstPartField: true,
        required:true
      },

      // SECTION C
      { section: "COLLECTION TIMING" },
      {
        label: "Date of Collection",
        type: "date",
        name: "collection_date",
        placeholder: "Select Collection Date",
        required: true,
        disabled: true,
        inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        noQuery: true,
        isResolve: resolveQueryUser,
        isFirstPartField: true,
      },
      {
        label: "Start Time",
        type: "time",
        name: "start_time",
        placeholder: "Select Start Time",
        required: true,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        noQuery: noQuery,
         isResolve: resolveQueryUser,
        isFirstPartField: true,
      },
      {
        label: "Stop Time",
        type: "time",
        name: "stop_time",
        placeholder: "Select Stop Time",
        required: true,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        noQuery: noQuery,
        isFirstPartField: true,
         isResolve: resolveQueryUser,
      },

      // SECTION D
      { section: "DISPATCH DETAILS" },
      {
        label: "Mode of Dispatch",
        type: "select",
        name: "mode_of_dispatch",
        placeholder: "Select Mode of Dispatch",
        options: DispatchModes,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        required: true,
        col: 2,
        noQuery: noQuery,
        isFirstPartField: true,
         isResolve: resolveQueryUser,
      },
      {
        label: "Logistics Partner",
        type: "select",
        name: "logistics_partner",
        placeholder: "Select Logistics Partner",
        required: true,
        options: LogisticsPartners,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        depend: "mode_of_dispatch",
        dependValue: "third_party",
        col: 2,
        noQuery: noQuery,
        isFirstPartField: true,
         isResolve: resolveQueryUser,
      },
      {
        label: "Data Logger Used",
        type: "text",
        name: "data_logger_used",
        placeholder: "Enter Data Logger Used",
        disabled: disabledAll || !isEditor || lsmKitRejected,
        max: 250,
        col: 2,
        noQuery: noQuery,
        isFirstPartField: true,
        isResolve: resolveQueryUser,
      },
      {
        label: "Data Logger Serial No",
        type: "text",
        name: "data_logger_serial_no",
        placeholder: "Enter Data Logger Serial No",
        disabled: disabledAll || !isEditor || lsmKitRejected,
        col: 2,
        isFirstPartField: true,
        noQuery: noQuery,
         isResolve: resolveQueryUser,
      },
      {
        label: "Equipment ID",
        type: "select",
        name: "equipment_id",
        placeholder: "Select Equipment ID",
        options: equipmentOptions,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        col: 2,
        noQuery: noQuery,
        isFirstPartField: true,
         isResolve: resolveQueryUser,
      },
      {
        label: "Date of Dispatch",
        type: "date",
        name: "date_of_dispatch",
        placeholder: "Select Date of Dispatch",
        required: true,
        min: new Date(),
        disabled: disabledAll || !isEditor || lsmKitRejected,
        inputClassName: "!py-[13px] !px-[13px]",
        col: 2,
        noQuery: noQuery,
        isFirstPartField: true,
         isResolve: resolveQueryUser,
      },
      {
        label: "Temperature at Dispatch (°C)",
        type: "number",
        name: "temperature_at_dispatch",
        placeholder: "Enter Temperature at Dispatch (°C)",
        isTempratureField: false,
        min: -80,
        max: 40,
        required: true,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        col: 2,
        noQuery: noQuery,
        isFirstPartField: true,
         isResolve: resolveQueryUser,
      },
      {
        label: "Time of Dispatch",
        type: "time",
        name: "time_of_dispatch",
        placeholder: "Select Time of Dispatch",
        required: true,
        noQuery: noQuery,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 2,
        isFirstPartField: true,
        isResolve: resolveQueryUser,
      },
      {
        label: "Upload Report/Log File",
        type: "file",
        name: "upload_report_log_file",
        placeholder: "Upload Report/Log File",
        acceptFormat: SUPPORTED_FORMATS,
        disabled: disabledAll || !isEditor || lsmKitRejected,
        removeButton: isEditor,
        onChange: handleUploadFile,
        removeFile: (name, id) => {
          setDeleteModal({ name: name, id: id });
        },
        downloadFile: handleDownload,
        noQuery: noQuery,
         isResolve: resolveQueryUser,
        col: 2,
        isFirstPartField: true,
      },
      {
        name: "alc",
        label: "ALC",
        type: "number",
        placeholder: "Enter ALC",
        required: true,
        noQuery: noQuery,
        extraContent:"× 10⁹ Cells",
        disabled: disabledAll || !isEditor || lsmKitRejected,
        col: 2,
       isResolve: resolveQueryUser
      },
      {
        label: "Editor Name",
        type: "text",
        name: "editor_name",
        placeholder: "Enter Editor Name",
        disabled: true,
        noQuery: true,
        col: 2,
        isFirstPartField: true,
     },
      {
        label: "Declaration",
        type: "checkbox",
        name: "alc_declaration",
        placeholder: "Checked Declaration",
        onChange:handleDeclarationModal,
        multiple: false,
        required: true,
        depend: "showAlcDeclaration",
        dependValue:"1",
        disabled: disabledAll || !isEditor || lsmKitRejected,
        options: ALCDelcarationOption,
        noQuery: noQuery,
        isResolve: resolveQueryUser,
        col: 2,
        isFirstPartField: true,
      },
    ],
    [
      lsmKitRejected,
      disabledAll,
      isEditor,
      patientData?.investigator?.hospital_details?.id,
      patientData?.id,
      formik.values?.lsm_volumes
    ]
  );
  //************ */ 
    // Form data for Inbound Second Part
  const inboundFormPartDFieldsData = useMemo(
    () => [
      // SECTION E
      { section: "Data Logger Files" },
      {
        name: "media_id",
        label: "Upload the Data Logger files",
        type: "file",
        placeholder: "Upload the Data Logger files",
        acceptFormat: SUPPORTED_FORMATS,
        disabled: ((!inBoundForm?.logger_media || inBoundForm.logger_media.length === 0)  && isLogistic ? false : !disableDraftFields) || lsmKitRejected || !isLogistic,
        removeButton: ((!inBoundForm?.logger_media || inBoundForm.logger_media.length === 0)  && isLogistic ? false : !disableDraftFields) || lsmKitRejected || !isLogistic,
        onChange: handleUploadFile,
        removeFile: (name, id) => {
          setDeleteModal({ name: name, id: id });
        },
        downloadFile: handleDownload,
        col: 2,
        noQuery: noQuery,
        required:true,
        isResolve: ["logistics-management"]
      }
    ],
    [disableDraftFields, lsmKitRejected,inBoundForm]
  );
  // Form data for Inbound Second Part
  const inboundFormPartBFieldsData = useMemo(
    () => [
      // SECTION E
      { section: "RECEIPT & VERIFICATION (IA Warehouse)" },
      {
        name: "date_of_receipt",
        label: "Date of Receipt",
        type: "date",
        required: true,
        placeholder: "Select Date of Receipt",
        disabled: !disableDraftFields || lsmKitRejected,
          // Allow only today → next 2 days
        min: new Date().toISOString().split("T")[0],
        max: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
        inputClassName: "!py-[13px] !px-[13px]",
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"],
      },
      {
        name: "temperature_at_receipt",
        label: "Temperature at Receipt (°C)",
        type: "number",
        placeholder: "Enter Temperature at Receipt (°C)",
        required: true,
        isTempratureField: true,
        min: -80,
        max: 30,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"],
      },
      {
        name: "time_of_receipt",
        label: "Time of Receipt",
        type: "time",
        required: true,
        placeholder: "Select Time of Receipt",
        disabled: !disableDraftFields || lsmKitRejected,
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"],
      },
      {
        name: "quantity_received",
        label: "No. of Bags",
        type: "number",
        placeholder: "Enter No. of Bags",
        required: true,
        disabled: !disableDraftFields || lsmKitRejected,
        // max: 5,
        notDecimal:true,
        noQuery: noQuery,
        col: 2,
        isResolve: ["warehouse"],
      },
      {
        name: "leakage",
        label: "Physical Check-Leakage",
        type: "radio",
        options: confirmationOptions,
        required: true,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"],
      },
      {
        name: "leakage_comment",
        type: "textarea",
        label: "Check-Leakage 's Comment",
        depend: "leakage",
        dependValue: "true",
        noQuery: true,
        required: true,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
      },
      {
        name: "seal_broken",
        label: "Seal Broken",
        type: "radio",
        required: true,
        options: confirmationOptions,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"],
      },
       {
        name: "seal_broken_comment",
        type: "textarea",
        label: "Seal Broken 's Comment",
        depend: "seal_broken",
        dependValue: "true",
        noQuery: true,
        required: true,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
      },
      {
        name: "transport_box_damaged",
        label: "Transport Box Damaged",
        type: "radio",
        required: true,
        options: confirmationOptions,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"],
      },
       {
        name: "transport_box_damaged_comment",
        type: "textarea",
        label: "Transport Box Damaged 's Comment",
        depend: "transport_box_damaged",
        dependValue: "true",
        noQuery: true,
        required: true,
        disabled: !disableDraftFields || lsmKitRejected,
        col: 2,
      },
      {
        name: "receipt_photo",
        label: "Receipt Photo",
        type: "file",
        placeholder: "Upload Receipt Photo",
        acceptFormat: SUPPORTED_FORMATS,
        disabled: !disableDraftFields || lsmKitRejected,
        removeButton: isEditor,
        onChange: handleUploadFile,
        removeFile: (name, id) => {
          setDeleteModal({ name: name, id: id });
        },
        downloadFile: handleDownload,
        col: 2,
        noQuery: noQuery,
        isResolve: ["warehouse"]
      },
      {
        name: "remarks",
        label: "Remarks",
        required: true,
        type: "textarea",
        placeholder: "Enter Remarks",
        disabled: !disableDraftFields || lsmKitRejected,
        max: 300,
        noQuery: true,
        col: 1,
      },
    ],
    [disableDraftFields, lsmKitRejected]
  );

  const inboundFormPartCFieldsData = useMemo(
    () => [
      // // SECTION F
      {
        section: "ALC REVIEW (IA QC ONLY)",
      },
      {
        name: "temperature_excursion",
        label: "Temperature Excursion",
        type: "radio",
        required: true,
        options: confirmationOptions,
        disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        col: 2,
        noQuery: noQuery || canPartiallyApproveLSMKit,
        isResolve: ["quality-check"],
      },
      {
        name: "temperature_excursion_comment",
        type: "textarea",
        label: "Temperature Excursion 's Comment",
        depend: "temperature_excursion",
        dependValue: "true",
        noQuery: true,
        required: true,
        disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        col: 2,
      },
      {
        name: "excursion_time",
        label: "Excursion Time",
        type: "time",
        required: true,
        placeholder: "Select Excursion Time (00:00)",
        depend: "temperature_excursion",
        dependValue: "true",
        disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        // inputClassName: "!py-[13px] !px-[13px]",
        col: 3,
        noQuery: noQuery || canPartiallyApproveLSMKit,
        isResolve: ["quality-check"],
      },
      {
        name: "excursion_temp",
        label: "Excursion Temperature (°C)",
        type: "number",
        required: true,
        placeholder: "Enter Excursion Temperature",
        depend: "temperature_excursion",
        dependValue: "true",
       disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        isTempratureField: true,
        min: -80,
        max: 30,
        noQuery: noQuery,
        col: 3,
        isResolve: ["quality-check"],
      },
      {
        name: "excursion_duration",
        label: "Excursion Duration (HH:MM)",
        type: "time",
        required: true,
        placeholder: "e.g. 22:00",
        // pattern: "^\\d{1,3}:([0-5]\\d)$", // optional: use your form lib to validate
        disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        depend: "temperature_excursion",
        dependValue: "true",
        col: 3,
        noQuery: noQuery,
        isResolve: ["quality-check"],
      },
      
      {
        name: "criteria_met",
        label: "ALC Criteria Met",
        type: "radio",
        options: confirmationOptions1,
        required: true,
        noQuery: noQuery || canPartiallyApproveLSMKit,
        isResolve: ["quality-check"],
        disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        col: 2,
      },
      {
        name: "declaration_to_proceed",
        type: "text",
        label: "Comment",
        noQuery: true,
        placeholder: "Enter Comment",
        required: true,
        // noVisible: !isEditor,
        // required: true,
        disabled: Boolean(lsmKitRejected || !canPartiallyApproveLSMKit),
        col: 2,
      }
    ], [lsmKitRejected, canPartiallyApproveLSMKit, isEditor, canFinalApproveLSMKit])

  const getCurrentStatus = useCallback(() => {
    const status = inBoundForm?.status;
    const successIcon = <CheckGreen Filled="#00B278" />;
    const infoIcon = <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />;

    if (!status) return null;

    switch (status) {
      case 1:
        return (
          <>
            {infoIcon}
            <Typography color="#FB9D2C">Draft</Typography>
          </>
        );
      case 2:
        return (
          <>
            {successIcon}
            <Typography color="#00B278">Submitted</Typography>
          </>
        );
      default:
        return (
          <>
            {successIcon}
            <Typography color="#00B278">Completed</Typography>
          </>
        );
    }
  }, [inBoundForm?.status]);

  const getStatusBasedColor = useCallback(() => {
    const status = inBoundForm?.status;
    switch (status) {
      case 1:
        return "#FB9D2C";
      case 2:
        return "#00B278";
      case 3:
        return "#00B278";
      default:
        return "#FB9D2C";
    }
  }, [inBoundForm]);

  const shouldFieldRaiseQuery = useCallback(
    (isFirstPartField, isThereQuery) => {
      if (isThereQuery) return true;
      const status = inBoundForm?.status;
      // When Form is Fully Approved we cannot raise query
      if (status === 3) return false;
      // For SuperAdmin
      if (role_id === 1) {
        return (status === 1 && isFirstPartField) || status > 1;
      }
      return (
        (canViewLSMKit && status >= 1) ||
        (canRaiseQueryOnFirstForm && isFirstPartField)
      );
    },
    [role_id, inBoundForm?.status, canViewLSMKit, canRaiseQueryOnFirstForm]
  );

   useEffect(()=>{
    if (formik?.values?.alc && formik?.values?.alc < 2) {
    formik.setFieldValue("showAlcDeclaration", ['1']);
  }else{
    formik.setFieldValue("showAlcDeclaration", []);
    formik.setFieldValue("alc_declaration", []);
    
  }
 },[formik?.values?.alc])


  const fieldsSet = useMemo(() => {
    if (enableForm1 && isEditor) {
      filterQueryData([...inboundFormPartDFieldsData,...inboundFormPartBFieldsData,...inboundFormPartCFieldsData])
      return inboundFormPartAFieldsData;
    }
    if (hasModulePermission && enableForm1 && enableForm2 && enableForm3 && enableForm4) {
      return [...inboundFormPartAFieldsData, ...inboundFormPartDFieldsData, ...inboundFormPartBFieldsData, ...inboundFormPartCFieldsData];
    }
     if (hasModulePermission && enableForm1 && enableForm2 && enableForm4) {
      filterQueryData(inboundFormPartCFieldsData)
      return [...inboundFormPartAFieldsData, ...inboundFormPartDFieldsData, ...inboundFormPartBFieldsData];
    }
    if (hasModulePermission && enableForm1 && enableForm2) {
            filterQueryData([...inboundFormPartCFieldsData,...inboundFormPartDFieldsData])
      return [...inboundFormPartAFieldsData, ...inboundFormPartBFieldsData];
    }
    if (hasModulePermission && enableForm1 && enableForm4) {
           filterQueryData([...inboundFormPartBFieldsData,...inboundFormPartCFieldsData])
      return [...inboundFormPartAFieldsData, ...inboundFormPartDFieldsData];
    }
    if (((hasModulePermission && enableForm1) || !enableForm4) || ((hasModulePermission && enableForm1) || !enableForm2)) {
      filterQueryData([...inboundFormPartDFieldsData,...inboundFormPartBFieldsData,...inboundFormPartCFieldsData])
      return inboundFormPartAFieldsData;
    }
    return [];
  }, [
    enableForm1,
    enableForm3,
    enableForm2,
    enableForm4,
    isEditor,
    hasModulePermission,
    inboundFormPartAFieldsData,
    inboundFormPartCFieldsData,
    inboundFormPartBFieldsData,
  ]);

  const handleFullPrint = (fields, values) =>{
setAllPrintData({fields, values, printPatientInfo,title:"In-Bound Form"})
    printTimeoutAllRef.current = setTimeout(() => {
      reactToPrintFnAll();
      // Clear the timeout reference after execution
      printTimeoutAllRef.current = null;
    }, 100);
}

  const handlePrintInbound = () =>{
    handleFullPrint(fieldsSet,formik?.values)
  }
  return (
    ((enableForm1 && isEditor) ||
     (enableForm1 && enableForm4 && !isEditor) ||
      (enableForm1 && enableForm2 && !isEditor) ||
      enableForm1 && enableForm2 && enableForm3 && enableForm4 && !isEditor) && (
      <Accordion
        key={`${role_id}-${enableForm1}-${enableForm2}-${enableForm3}-${inBoundForm?.id || currentCycle?.inbond_patients_id
          }`} // <-- Unique key added
        className="w-100 !pt-2 !rounded-lg"
        sx={{
          borderLeft: `4px solid ${!inBoundForm?.status ||
            queriesFields?.filter((op) => op.resolve == 0)?.length > 0
            ? "#FB9D2C"
            : getStatusBasedColor()
            }`,
        }}
        expanded={InBoundFormExpanded}
        onChange={() => setInBoundFormExpanded((prev) => !prev)}
      >
       <AccordionSummary
  expandIcon={
    <div className="d-flex gap-3 align-items-center">
      <DownIcon />
    </div>
  }
  aria-controls="panel1-content"
  id="panel1-header"
>
  {isLoading ? (
    <div>
      <SkeletonLoader
        rowCount={1}
        height={30}
        width={200}
        isTable={false}
      />
      <div className="flex gap-2">
        <SkeletonLoader
          rowCount={2}
          height={30}
          width={140}
          isTable={false}
        />
      </div>
    </div>
  ) : (
    <div className="flex w-full items-center justify-between mr-2">
      
      {/* LEFT CONTENT */}
      <div className="flex flex-col gap-2">
        <span className="font-bold text-[0.9rem]">In-Bound Form</span>

        <div className="flex gap-2 items-center">
          {!inBoundForm?.status ||
          queriesFields?.filter((op) => op.resolve == 0)?.length > 0 ? (
            <span className="flex gap-2 items-center text-[#FB9D2C]">
              <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
              In-Progress
            </span>
          ) : (
            <span className="flex gap-2 items-center text-[#00B278]">
              {getCurrentStatus()}
            </span>
          )}

          {queriesFields?.filter((op) => op.resolve == 0)?.length > 0 && (
            <div className="flex gap-2 items-center">
              <div className="border-l-2 h-5" />
              <Typography
                variant="body1"
                className="ml-2 rounded-full flex items-center justify-center
                text-[0.75rem] w-[1.2rem] h-[1.2rem] text-white bg-[#FF0000]"
              >
                {queriesFields?.filter((op) => op.resolve == 0)?.length}
              </Typography>
              <span className="text-red-600 text-[0.8rem]">
                Query Raised
              </span>
            </div>
          )}
        </div>
      </div>

      {/* RIGHT BUTTON */}
      {isInBoundPrint && <LoadingButton
        type="button"
        size="small"
        onClick={handlePrintInbound}
        className="!w-[100px]"
      >
        Print
      </LoadingButton>}

    </div>
  )}
</AccordionSummary>

        <AccordionDetails>
          <Divider />
          {isLoading ? (
            <SkeletonLoader rowCount={5} height={80} isTable={false} />
          ) : (
            <div>
              <InBoundQueryHistory
                inBoundId={currentCycle?.inbond_patients_id}
              />
              <form className="!mt-2" onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                  {fieldsSet?.map((props, key) => {
                    if (props.noVisible) {
                      return null;
                    }
                    // Skip rendering if the field has a depend condition that's not met
                    if (props.depend) {
                      const dependVal = formik.values[props.depend];
                      const dependValues = props?.dependValue?.includes(",")
                        ? props.dependValue?.split(",").map((v) => v.trim())
                        : [props.dependValue];

                      if (Array.isArray(dependVal)) {
                        if (
                          !dependVal?.some((val) =>
                            dependValues?.includes(`${val}`)
                          )
                        ) {
                          return null;
                        }
                      } else {
                        if (!dependValues?.includes(`${dependVal}`)) {
                          return null;
                        }
                      }
                    }
                    if (props.section) {
                      return (
                        <Grid key={key} item xs={12} className="">
                          {/* Rest of your field rendering code */}
                          {props.section && (
                            <strong className="!pb-3">{props.section}</strong>
                          )}
                        </Grid>
                      );
                    }

                    return !props.manualField ? (
                      <Grid
                        key={key}
                        item
                        xs={props.col && !props.children ? 12 / props.col : 12}
                      >
                        {/* Rest of your field rendering code */}
                        {props.section && (
                          <strong className="!pb-3">{props.section}</strong>
                        )}
                        <FormControl
                          variant={props.variant ?? "standard"}
                          fullWidth={props.fullWidth ?? true}
                          className={`pl-3 pr-3 ${props.section ? "pt-3" : ""
                            } ${props.className ?? ""}`}
                        >
                          {/* Field labels */}
                          {props.label && props.children && (
                            <FormLabel
                              shrink
                              required={props.required}
                              className="text-[black]"
                            >
                            {props.label}
                            </FormLabel>
                          )}
                          {props.subLable && (
                           <Typography
                            variant="span"
                            className={`z-[1] font-semibold absolute right-2 ${formik.errors[props.name] && formik.touched[props.name]
                                ? 'bottom-9'   // move higher when error shows
                                : 'bottom-4'   // default position
                                } text-[0.7rem]`}
                        >
                               {props.subLable === "power" ? (
                                    <p>
                                        x 10<sup>9</sup>
                                    </p>
                                ) : (
                                    props.subLable
                                )}
                            </Typography>
                          )}
                          {/* Fields */}
                          {!props.manualValues &&
                            !props.isObj &&
                            (() => {
                              const value = checkInBoundForm[props.name];
                               let questionInfo = queriesFields?.find(
                              (op) =>
                                op?.fields?.field_name === props.name
                            );
                             if(!questionInfo){
                              let depended = props.depend
                              if(props.depend == 'showAlcDeclaration')
                                depended = 'alc';
                               questionInfo = queriesFields?.find(
                              (op) =>
                                op?.fields?.field_name == depended
                            );
                             }
                              return (
                                <div className="relative">
                                  <FormikControl
                                    formik={formik}
                                    {...props}
                                    disabled={
                                      questionInfo?.resolve == 0 ? false : props.disabled
                                    }
                                    // disabled={
                                    //   // !canViewLSMKit ||
                                    //   // !canViewLSMReceiptForm ||
                                    //   disableReceivedFields||
                                    //   questionInfo?.resolve !== 0&&
                                    //     props.disabled
                                    // }
                                    className="mt-2"
                                  />
                                  {!props.noQuery &&
                                    (questionInfo?.resolve == 0 || (typeof value === "number"
                                      ? value === 0 || value !== ""
                                      : (value !== "" && value !== null))) &&
                                    (props.disabled || disabledAll) &&
                                    props.type != "file" ? (
                                    <i
                                      onClick={(e) =>
                                        handleQuestionClick(
                                          e,
                                          props,
                                          questionInfo
                                        )
                                      }
                                      style={
                                        questionInfo?.resolve == 0 &&
                                          questionInfo.fields?.field_name?.trim() ===
                                          props.name?.trim()
                                          ? { color: "red" }
                                          : {}
                                      }
                                      className={`fas fa-question-circle circle-icon cursor-pointer z-50 absolute right-2 ${!props.label && props.type != "radio"
                                        ? "top-[1.2rem]"
                                        : props.type == "radio"
                                          ? "top-[2rem]"
                                          : "top-[0.6rem]"
                                        }`}
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              );
                            })()}

                          {/* Children Fields */}
                          {props.children &&
                            (props.isObj ? (
                              <div className="flex gap-3">
                                {props.children.map(
                                  (subFieldProps, subFieldPropsIndex) => {
                                    const questionInfo = queriesFields?.find(
                                      (op) =>
                                        op.fields?.field_name ===
                                        subFieldProps.name
                                    );
                                    return (
                                      <div
                                        key={subFieldPropsIndex}
                                        className="w-full relative"
                                      >
                                        <FormikControl
                                          formik={formik}
                                          {...subFieldProps}
                                          disabled={
                                            questionInfo?.resolve == 0 &&
                                            props.disabled
                                          }
                                        />
                                        {!subFieldProps.noQuery &&
                                          (props.disabled || disabledAll) && (
                                            <i
                                              onClick={(e) =>
                                                handleQuestionClick(
                                                  e,
                                                  subFieldProps,
                                                  questionInfo
                                                )
                                              }
                                              style={
                                                questionInfo?.resolve == 0
                                                  ? {
                                                    color: "red",
                                                  }
                                                  : {}
                                              }
                                              className="fas fa-question-circle circle-icon cursor-pointer z-50 absolute top-[2.1rem] right-6"
                                              aria-hidden="true"
                                            ></i>
                                          )}
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : (
                              <FormikArrayInBound
                                handleQuestionClick={handleQuestionClick}
                                props={props}
                                formik={formik}
                                isEditor={isEditor}
                                disabledAll={disabledAll}
                                queriesFields={queriesFields}
                                shouldFieldRaiseQuery={shouldFieldRaiseQuery}
                              />
                            ))}
                        </FormControl>
                      </Grid>
                    ) : (
                      <Grid
                        key={key}
                        item
                        xs={12}
                        className="flex align-items-baseline"
                      ></Grid>
                    );
                  })}
                </Grid>
                {LSMApprovalDetails &&
                  <LSMApprovalDetails formik={formik} />}
                <Grid container spacing={2}>
                  <Grid item xs={12} className="text-center mb-2 gap-3 flex">
                   { !isLogistic && !lsmKitCompleted && (enableSubmitButton || canPartiallyApproveLSMKit) && <LoadingButton
                        type="submit"
                        size="small"
                        onClick={() => setIsDraft(true)}
                        className="!w-[100px] bg-[#ffa500]"
                      >
                        Save as Draft
                      </LoadingButton>}
                    {((!isLogistic && !lsmKitCompleted && enableSubmitButton) || (!lsmKitCompleted && isLogistic && enableForm4 && (!inBoundForm?.logger_media || inBoundForm?.logger_media?.length === 0))) && <Tooltip
                      title={
                        queriesNotResolved?.length
                          ? !isEditor
                            ? "Resolve the queries for submit"
                            : "Submit Form"
                          : "Submit Form"
                      }
                    >
                      {/* {!disabledAll && !canViewLSMKit && ( */}
                      <LoadingButton
                        className="bg-[#00B278] w-[10rem] "
                        loading={isLoading}
                        type="submit"
                         onClick={() => setIsDraft(false)}
                        disabled={(!lsmKitRejected && isLogistic && enableForm4 && (!inBoundForm?.logger_media || inBoundForm?.logger_media?.length == 0)) ? false : (!enableSubmitButton || lsmKitRejected)}
                        variant="contained"
                      >
                        Submit
                      </LoadingButton>
                    </Tooltip>}
                    {!lsmKitRejected && canPartiallyApproveLSMKit &&
                      <LoadingButton
                        type="submit"
                        size="small"
                         onClick={() => setIsDraft(false)}
                        className="!w-[100px] bg-[#00B278]"
                      >
                        Submit
                      </LoadingButton>}
                    {/* {(((canPartiallyRejectLSMKit || canFinalRejectLSMKit || canSubmitedRejectLSMKit) && !lsmKitRejected) || (!lsmKitCompleted && enableSubmitButton && canRejectLSMKit)) && <LoadingButton
                      onClick={() => setShowRejectLSM(true)}
                      size="small"
                      disabled={lsmKitRejected}
                      className="!w-[100px] bg-[#FA5151]"
                    >
                      Reject
                    </LoadingButton>} */}
                  </Grid>
                </Grid>
              </form>
              <InBoundComment
                formValues={formik.values}
                checkInBoundForm={checkInBoundForm}
                handleManualFormikValidaction={handleManualFormikValidaction}
                handleMenuClose={handleMenuClose}
                open={open}
                anchorEl={anchorEl}
                selectedField={selectedField}
                queryData={queryData}
                getPrimaryDiagnosis={fetchInboundDetails}
                initialSteps={initialSteps}
              />
            </div>
          )}
        </AccordionDetails>
        <DeleteModal
          open={deleteModal}
          setClose={setDeleteModal}
          title={"Are you sure you want to Delete File ?"}
          buttonText={"Delete"}
          handleSuccess={hanldeRemoveFiles}
        />
        <RejectLSM
          open={showRejectLSM}
          setOpen={setShowRejectLSM}
          feasibility_assessments_id={currentCycle?.feasibility_assessments_id}
          qrCode_id={patientData?.qrCode_id}
          handleSubmitRejectLSM={handleSubmitRejectLSM}
        />
        <BsModal size={'sm'} open={showALCModal} onClose={()=>setShowALCModal(false)} title={'Declaration'}>
          <ALCDelaration formik={formik}  setShowALCModal={setShowALCModal}/>
      </BsModal>

         {allPrintData && (
                <div style={{ display: "none" }}>
                <QrAllPrintContent
                  printData={allPrintData}
                  ref={printContentAllRef}
                /></div>
            )}

      </Accordion>
    )
  );
};

export default InBoundForm;
